export const Paginator = (props) => {
    return (
        [...Array(props.pagesCount).keys()].map(p => (
            <li key={`page-${p}`} className={`page-item ${props.currentPage == p ? "active" : "" }`} onClick={() => {props.setCurrentPage(p)}}><a className="page-link" href="#">{p}</a></li>
        ))
    );
}